$(".toggle-extra-items").click(function(){
    $('.extra-item').toggleClass('hidden');
    
 })